export enum PreviewSizes {
  chip = 28,
  xsmall = 32,
  small = 64,
  xmid = 128,
  mid = 256,
  large = 1024,
}
